import React, {Fragment} from 'react'
//import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'

const tableStyle = {
  backgroundColor: '#ffffff',
}

const divStyle = {
  paddingTop: '30px',
}

const aStyle = {
  display: 'none',
}

const h3Style = {
  paddingBottom: '20px',
}

const divTableStyle = {
  float: 'left',
  paddingLeft: '0px',
  paddingRight: '20px',
}

const linkStyle = {
  fontWeight: 'normal',
  color: 'black',
  border: 'none',
}

const divlinkStyle = {
  width: '50%',
  display: 'inline',
  float: 'left',
}

const divlink2Style = {
  display: 'inline',
}

const tbodyStyle = {
  maxHeight: '500px',
  overflow: 'scroll',
  display: 'block',
  width: '100%',
}

const trStyle = {
  width: '99%',
}

const thStyle = {
  width: '45%',
}

const th2Style = {
  width: '63%',
}

class ManageMembers extends React.Component {
  constructor(props) {
    super(props)
  }

  handleChangeManager(id, value) {
    let man = false
    if (value === false) {
      man = true
    } else {
      man = false
    }
    const body = JSON.stringify({user_id: id, type: 'update', manager: man})
    const urlf = '/api/v1/teams/' + this.props.team.id + '/manage_members'
    const meth = 'POST'
    fetch(urlf, {
      method: meth,
      headers: {
        'Content-Type': 'application/json',
      },
      body: body,
    })
    .then(response => response.json())
    .then(() => {
      document.getElementById('mylink').click()
    })
    .catch((err) => {
      console.error('Error while managing members! ' + err)
    })
  }

  handleChangeMember(id) {
    const body = JSON.stringify({user_id: id, type: 'create', manager: false})
    const urlf = '/api/v1/teams/' + this.props.team.id + '/manage_members'
    const meth = 'POST'
    fetch(urlf, {
      method: meth,
      headers: {
        'Content-Type': 'application/json',
      },
      body: body,
    })
    .then(response => response.json())
    .then(() => {
      document.getElementById('mylink').click()
    })
    .catch((err) => {
      console.error('Error while managing members! ' + err)
    })
  }

  handleChangeRemove(id) {
    const body = JSON.stringify({user_id: id, type: 'remove', manager: false})
    const urlf = '/api/v1/teams/' + this.props.team.id + '/manage_members'
    const meth = 'POST'
    fetch(urlf, {
      method: meth,
      headers: {
        'Content-Type': 'application/json',
      },
      body: body,
    })
    .then(response => response.json())
    .then(() => {
      document.getElementById('mylink').click()
    })
    .catch((err) => {
      console.error('Error while managing members! ' + err)
    })
  }

  renderHeader() {
    return <Fragment><th key="name" style={thStyle}>Name</th><th key="actions" colSpan="2" style={thStyle}>Actions</th></Fragment>
  }

  renderData() {
    const myData = [].concat(Object.values(this.props.members)).sort((a, b) => a['name'].localeCompare(b['name']))
    return Object.keys(myData).map((key) => {
      const member = myData[key]
      const valueCh = member['manager']
      const idM = member['id']
      let option = ''
      if (valueCh === true){
        option = 'Demote to member'
      } else {
        option = 'Promote to manager'
      }
      return <tr key={key} style={trStyle}><td>{ valueCh && <i className="fa fa-star" aria-hidden="true"></i> }{member['name']}</td><td colSpan="2"><div style={divlinkStyle}><a href="#" onClick={() => this.handleChangeManager(idM, valueCh)} style={linkStyle}>{option}</a></div><div style={divlink2Style}><a href="#" onClick={() => this.handleChangeRemove(idM)} style={linkStyle}>Remove from team</a></div></td></tr>
    }
    )
  }

  renderHeaderNonmembers() {
    return <Fragment><th key="name" style={th2Style}>Name</th><th key="actionsnewmembers" style={th2Style}>Actions</th></Fragment>
  }

  renderDataNonmembers() {
    const myData = [].concat(Object.values(this.props.nonmembers)).sort((a, b) => a['name'].localeCompare(b['name']))
    return Object.keys(myData).map((key) => {
      const nonmember = myData[key]
      const idN = nonmember['id']
      return <tr key={key} style={trStyle}><td>{nonmember['name']}</td><td><a href="#" onClick={() => this.handleChangeMember(idN)} style={linkStyle}>Add to team</a></td></tr>
    }
    )
  }

  render() {
    const l = '/teams/' + this.props.team.id + '/members'
    return <div className="row col-sm-12" style={divStyle}><div className="row col-sm-12"><h3 style={h3Style}>Manage members for {this.props.team.name}</h3><h3 style={{ display: this.props.team.oncall === true ? 'inline-block' : 'none'}}>(OnCall Team)</h3></div><br /><a href={l} style={aStyle} id="mylink"></a><div className="col-sm-8" style={divTableStyle}><h5>Members</h5><table className="table" style={tableStyle}><tbody style={tbodyStyle}><tr style={trStyle}>{this.renderHeader()}</tr>{this.renderData()}</tbody></table></div><div className="col-sm-4" style={divTableStyle}><h5>Non-Members</h5><table className="table" style={tableStyle}><tbody style={tbodyStyle}><tr style={trStyle}>{this.renderHeaderNonmembers()}</tr>{this.renderDataNonmembers()}</tbody></table></div></div>
  }
}

ManageMembers.propTypes = {
  team: PropTypes.object,
  members: PropTypes.array,
  nonmembers: PropTypes.array,
}


export default ManageMembers
